module.exports = __webpack_public_path__ + "static/media/bone2_Bitmap.42d23e17.png";